import React, { useState, useEffect, useRef } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import { lang } from "../../middleware/lang";
import useSettings from "../../hooks/settings";
import { hasIngredient } from "../../middleware/product_functions";
import { formatNumber } from "../../middleware/common-functions";

export const ModalIng = ({
  open,
  toggle,
  className,
  product,
  click,
  handleSum,
  handleLess,
  handleQty,
  addProduct,
}) => (
  <Modal isOpen={open} toggle={toggle} className={className}>
    <ModalHeader toggle={toggle}>{product.title}</ModalHeader>
    <ModalBody>
      {product.ingredients.length > 0 ? (
        <ChooseIngredients
          ingredients={product.ingredients}
          click={click}
          product={product}
          text={
            product.text_ing && product.text_ing.length
              ? "Sin " + product.text_ing.join(", ")
              : "Con Todo"
          }
        />
      ) : (
        <h5 className="text-center">Sin Ingredientes a Escoger</h5>
      )}
      <Quantytiy
        handleSum={handleSum}
        handleLess={handleLess}
        handleQty={handleQty}
        qty={product.qty}
      />
    </ModalBody>
    <ModalFooter>
      <Button
        className="btn btn-success btn-block btn_xs_lg"
        onClick={addProduct}
      >
        Listo
      </Button>
    </ModalFooter>
  </Modal>
);

const Ingredient = ({ info, click, active }) => (
  <button
    type="button"
    className={`btn btn-flat ripple-effect btn-toggle-primary px-1 ingredient_btn ${
      active ? "active" : null
    }`}
    data-ing={+info.id}
    onClick={click}
  >
    <i className={info.icon}></i>
    <br />
    <small>{info.name}</small>
  </button>
);

const Quantytiy = (props) => (
  <div className="product_quantity">
    <hr />
    <div className="input-group mb-3 input-group-lg">
      <div className="input-group-prepend" id="product_quantity_cont">
        <button
          className="btn btn-lg btn-transparent text-center  text-muted"
          id="minus_button"
          type="button"
          onClick={props.handleLess}
        >
          <i className="fas fa-minus"></i>
        </button>
      </div>

      <input
        type="tel"
        className="form-control text-center border-0"
        aria-label="Product Quantity"
        onChange={props.handleQty}
        aria-describedby="product_quantity_cont"
        value={props.qty}
      />

      <div className="input-group-append" id="button-addon4">
        <button
          className="btn btn-lg btn-transparent text-center "
          type="button"
          onClick={props.handleSum}
        >
          <i className="fas fa-plus"></i>
        </button>
      </div>
    </div>
  </div>
);

// Flash a button by index then call action after animation
const flashAndAct = (containerSelector, idx, action, delay = 300) => {
  const container = document.querySelector(containerSelector);
  if (container) {
    const buttons = container.querySelectorAll(".pos-kbd-btn");
    const btn = buttons[idx];
    if (btn) {
      btn.classList.remove("kbd-flash");
      // Force reflow to restart animation
      void btn.offsetWidth;
      btn.classList.add("kbd-flash");
    }
  }
  setTimeout(action, delay);
};

// Helper: keyboard listener for option group modals
const KeyboardOptionHandler = ({ open, options, isRadio, maxSelections, groupIdx, onSelectOption, onToggleOption, onNext, canContinue }) => {
  const pendingRef = useRef(false);
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (pendingRef.current) return;
      if (e.key === "Enter" && !isRadio && canContinue) {
        onNext();
        return;
      }
      const num = parseInt(e.key, 10);
      if (num >= 1 && num <= options.length) {
        const opt = options[num - 1];
        pendingRef.current = true;
        flashAndAct(".og-slide-container", num - 1, () => {
          pendingRef.current = false;
          if (isRadio) {
            onSelectOption(groupIdx, opt);
          } else {
            onToggleOption(groupIdx, opt, maxSelections);
          }
        });
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [open, options, isRadio, maxSelections, groupIdx, onSelectOption, onToggleOption, onNext, canContinue]);
  return null;
};

export const ModalOptions = ({ open, toggle, className, product, click, next }) => {
  const optionsSlice = product.options.slice(0, 9);

  const pendingRef = useRef(false);
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (pendingRef.current) return;
      const num = parseInt(e.key, 10);
      if (num >= 1 && num <= optionsSlice.length) {
        const opt = optionsSlice[num - 1];
        pendingRef.current = true;
        flashAndAct("#modal_options", num - 1, () => {
          pendingRef.current = false;
          const fakeEvent = { currentTarget: { dataset: { ing: opt.id } } };
          click(fakeEvent);
        });
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [open, optionsSlice, click]);

  return (
    <Modal
      isOpen={open}
      toggle={toggle}
      className={className}
    >
      <ModalHeader toggle={toggle}>
        {product.title}
        {product.has_option > 1 ? (
          <p className="my-1">
            Escoge hasta <b>{product.has_option}</b> opciones
          </p>
        ) : null}
      </ModalHeader>
      <ModalBody>
        <div className="d-sm-block w-100 justify-content-between">
          <div className="" data-toggle="buttons" id="modal_options">
            {optionsSlice.map((option, idx) => (
              <button
                className={`btn btn-outline-dark btn_xs_lg btn-block product_size pos-kbd-btn ${
                  option.active ? "active" : ""
                }`}
                data-ing={option.id}
                key={`option_id${option.id}`}
                onClick={click}
              >
                <span className="pos-kbd-num">{idx + 1}</span>
                {option.ingredient.name}
                {option.price_mod ? (
                  <b className="text-danger"> | + ${option.price_mod}</b>
                ) : null}
              </button>
            ))}
          </div>
        </div>
      </ModalBody>
      {product.has_options > 1 ? (
        <ModalFooter>
          <button className="btn btn-block btn-danger" onClick={next}>
            Continuar
          </button>
        </ModalFooter>
      ) : null}
    </Modal>
  );
};

export const ModalOptionGroup = ({ open, toggle, product, group, groupIdx, onSelectOption, onToggleOption, onNext, onBack, stepLabel }) => {
  const [slideClass, setSlideClass] = useState("og-slide-in");
  const prevGroupRef = useRef(group?.id);

  useEffect(() => {
    if (group && prevGroupRef.current !== group.id) {
      setSlideClass("og-slide-out");
      const timer = setTimeout(() => {
        prevGroupRef.current = group.id;
        setSlideClass("og-slide-in");
      }, 150);
      return () => clearTimeout(timer);
    }
  }, [group]);

  if (!group) return null;
  const isRadio = group.max_selections === 1;
  const isRequired = group.min_selections > 0;
  const selectedCount = Object.keys(group.selectedOptions || {}).length;
  const canContinue = selectedCount >= group.min_selections;

  return (
    <Modal isOpen={open} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {product.title}
        <p className="my-1 mb-0">
          <strong>{group.name}</strong>
          {stepLabel && <small className="text-muted ml-2">{stepLabel}</small>}
        </p>
        {isRequired ? (
          <small className="text-warning">
            {lang("Requerido", "Required")}
            {!isRadio ? ` — ${lang("mín", "min")} ${group.min_selections}, ${lang("máx", "max")} ${group.max_selections}` : ""}
          </small>
        ) : !isRadio ? (
          <small className="text-muted">
            {lang(`Escoge hasta ${group.max_selections}`, `Pick up to ${group.max_selections}`)}
          </small>
        ) : (
          <small className="text-muted">
            {lang("Escoge uno", "Pick one")}
          </small>
        )}
      </ModalHeader>
      <ModalBody>
        <KeyboardOptionHandler
          open={open}
          options={group.options.slice(0, 9)}
          isRadio={isRadio}
          maxSelections={group.max_selections}
          groupIdx={groupIdx}
          onSelectOption={onSelectOption}
          onToggleOption={onToggleOption}
          onNext={onNext}
          canContinue={canContinue}
        />
        <div className={`og-slide-container ${slideClass}`} data-toggle="buttons" id="modal_options">
          {group.options.slice(0, 9).map((option, idx) => {
            const isSelected = !!(group.selectedOptions && group.selectedOptions[option.id]);
            return (
              <button
                className={`btn btn-outline-dark btn_xs_lg btn-block product_size pos-kbd-btn ${
                  isSelected ? "active" : ""
                }`}
                key={`grp-${group.id}-opt-${option.id}`}
                onClick={() => {
                  if (isRadio) {
                    onSelectOption(groupIdx, option);
                  } else {
                    onToggleOption(groupIdx, option, group.max_selections);
                  }
                }}
              >
                <span className="pos-kbd-num">{idx + 1}</span>
                {option.ingredient ? option.ingredient.name : `Option ${option.id}`}
                {option.price_mod ? (
                  <b className="text-danger"> | + ${option.price_mod}</b>
                ) : null}
              </button>
            );
          })}
        </div>
      </ModalBody>
      <ModalFooter className="d-flex">
        {onBack ? (
          <Button
            className="btn btn-outline-secondary btn_xs_lg"
            onClick={onBack}
            style={{ flex: "0 0 auto" }}
          >
            <i className="fas fa-chevron-left"></i>
          </Button>
        ) : null}
        <Button
          className="btn btn-success btn_xs_lg flex-grow-1"
          onClick={onNext}
          disabled={!canContinue}
        >
          {canContinue
            ? lang("Continuar", "Continue")
            : lang("Selecciona una opción", "Select an option")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export const ModalSizes = ({ open, toggle, className, title, sizes, click }) => {
  const sizeKeys = Object.keys(sizes).slice(0, 9);

  const pendingRef = useRef(false);
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (pendingRef.current) return;
      const num = parseInt(e.key, 10);
      if (num >= 1 && num <= sizeKeys.length) {
        const key = sizeKeys[num - 1];
        pendingRef.current = true;
        flashAndAct("#modal_options", num - 1, () => {
          pendingRef.current = false;
          const fakeEvent = { currentTarget: { dataset: { ing: key } } };
          click(fakeEvent);
        });
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [open, sizeKeys, click]);

  return (
    <Modal
      isOpen={open}
      toggle={toggle}
      className={className}
    >
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        <div className="d-sm-block w-100 justify-content-between">
          <div className="" data-toggle="buttons" id="modal_options">
            {sizeKeys.map((key, idx) => (
              <button
                className="btn btn-outline-dark btn_xs_lg btn-block product_size pos-kbd-btn"
                data-ing={key}
                key={key}
                onClick={click}
              >
                <span className="pos-kbd-num">{idx + 1}</span>
                {sizes[key].name}
                {sizes[key].price ? <b> | ${sizes[key].price}</b> : null}
              </button>
            ))}
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export const ModalTables = ({
  open,
  toggle,
  makeOrder,
  tables,
  active_table,
}) => {
  return (
    <Modal isOpen={open} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        {lang("Selecciona Mesa", "Select Table")}
      </ModalHeader>
      <ModalBody>
        <div className="d-sm-block w-100 justify-content-between">
          <div className="" data-toggle="buttons" id="modal_options">
            {tables.map((table, index) => (
              <button
                className={`btn btn_helper rounded_plus p-5 m-1 my-3 btn-outline-dark ${
                  table.is_active || active_table === +table.id ? "active" : ""
                }`}
                data-table_id={table.id}
                key={`table-${table.id}-${index}`}
                onClick={makeOrder}
              >
                {table.name || table.id}
              </button>
            ))}
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export const ModalChangePrice = (props) => {
  const showCalc =
    props.price_calc != null &&
    String(props.price) !== String(props.price_calc);
  return (
    <Modal
      isOpen={props.open}
      toggle={props.toggle}
      size="lg"
      autoFocus={false}
    >
      <ModalHeader toggle={props.toggle}>
        {lang("Modificar Precio", "Change Price")}
      </ModalHeader>
      <ModalBody>
        <div className="d-sm-block w-100 justify-content-between">
          <div className="" data-toggle="buttons">
            <div className="input-group mb-3 input-group-lg">
              <input
                type="text"
                className="form-control text-center border-0 display_10"
                placeholder="ej: 150+10%"
                aria-label="Product Price"
                aria-describedby="product_price_ch_cont"
                onChange={props.inputFun}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    props.click();
                  }
                }}
                value={props.price}
                autoFocus
              />
            </div>
          </div>
          <h2
            className={`price_result text-secondary text-right animate_all ${
              showCalc ? "opacity_7" : "opacity_0"
            }`}
            style={{ marginBottom: "4px" }}
          >
            = $<span>{showCalc ? formatNumber(props.price_calc) : ""}</span>
          </h2>
          <p
            className="text-muted text-right"
            style={{ fontSize: "12px", marginTop: "0" }}
          >
            {lang(
              "Ej: 150+10, 200-15%, 100*2, 300/3",
              "E.g.: 150+10, 200-15%, 100*2, 300/3"
            )}
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <button
          type="button"
          className="btn btn-danger btn-block btn_xs_lg"
          onClick={props.click}
        >
          Aceptar
        </button>
      </ModalFooter>
    </Modal>
  );
};

export const ModalComments = (props) => {
  return (
    <Modal
      isOpen={props.open}
      toggle={props.toggle}
      size="lg"
      autoFocus={false}
    >
      <ModalHeader toggle={props.toggle}>
        {lang("Comentarios", "Add Comments")}
      </ModalHeader>
      <ModalBody>
        <div className="input-group mb-3 input-group-lg">
          <textarea
            type="text"
            className="form-control"
            aria-label="Product Comments"
            aria-describedby="product_comment_cont"
            spellCheck="false"
            onChange={props.inputFun}
            autoFocus
            value={props.comments}
          ></textarea>
        </div>
        <div className="row">
          <div className="col">
            <small className="form-text text-muted">
              {lang("Máximo 150 caracteres", "Max 150 Ch")}
            </small>
          </div>
          <div className="col text-right">
            {props.comments ? (
              <small className="form-text text-muted">
                Quedan {150 - props.comments.length}
              </small>
            ) : null}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <button
          type="button"
          className="btn btn-danger btn-block btn_xs_lg"
          onClick={props.click}
        >
          {lang("Guardar", "Save")}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export const ModalOrder = (props) => {
  const [settings] = useSettings();
  let count = 0;
  if (!props.order.products) {
    return <>...</>;
  }
  props.order.products.map((item, key) => (count = item.qty + count));
  return (
    <div
      className={`modal-cover container- px-0 px-sm-2 ${
        props.show ? "" : "display_none"
      }`}
    >
      <div className="container py-3 px-sm-2">
        <div className="doughnut fixed"></div>
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="row align-items-center">
              <div className="col-2">
                <button
                  type="button"
                  className="btn btn-block min_width_xs_1 text-muted"
                  onClick={props.back}
                >
                  <i className="fa fa-chevron-left" aria-hidden="true"></i>{" "}
                </button>
              </div>
              <div className="col-10">
                <h2>Resumen del Pedido</h2>
              </div>
            </div>
            <div className="material_card pos_panel p-3 scrolleable">
              <div className="row my-2">
                <div className="col-8">Producto</div>
                <div className="col-4">Precio</div>
              </div>
              <div className="order_summary fix_vh_40 ">
                {props.order.products.map((item, key) => (
                  <ListMov
                    key={key}
                    product={item}
                    index={key}
                    removeProduct={props.removeProduct}
                    changePrice={props.changePrice}
                    addComment={props.addComment}
                    openOptions={props.openOptions}
                  />
                ))}
              </div>
              <div className="col-12">
                <hr />
                <div className="row">
                  <div className="col-7">
                    <p className="media-body m-0 small lh-125">
                      Productos <span className="products_num">{count}</span>
                    </p>
                  </div>

                  <div className="col-5 p-0">
                    {" "}
                    <button
                      type="button"
                      // onClick="add_comments_promt('all')"
                      className="btn btn-transparent min_with_1 btn-block m-0 text-right"
                    >
                      <i className="far fa-comments-alt text-muted ordercomments"></i>
                    </button>
                  </div>
                </div>

                <hr />
              </div>

              <div className="col">
                <h3 className="text-right">
                  Total: $
                  <span className="order_totals">{props.order.total}</span>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row p-0 px-sm-0 m-0 fixed_bottom_mov material-shadows_mov d-lg-none align-items-baseline">
        <div className="col ">
          <Delivery type="pickup" click={props.makeOrder} />
        </div>
        {settings.disable_delivery ? null : (
          <div className="col ">
            <Delivery type="delivery" click={props.makeOrder} />
          </div>
        )}
        <div className="col mt-2">
          <Delivery type="for_here" click={props.makeOrder} />
        </div>
        <div className="col mt-2">
          <Delivery type="other_apps" click={props.makeOrder} />
        </div>
      </div>

      <div className="modal-footer xs_hidden sm_hidden">
        <button
          type="button"
          className="btn btn-raised btn-outline-dark ripple-effect"
          data-dismiss="modal"
          // onClick="make_order(false)"
        >
          <i className="fa fa-chevron-left" aria-hidden="true"></i> Atrás
        </button>
        <button
          type="button"
          className="btn btn-raised btn-danger btn-block ripple-effect btn_xs_lg un_disabled"
          id="make_order_btn_tab"
          // onClick="confirm_order()"
        >
          Hacer Pedido
        </button>
      </div>
    </div>
  );
};

export const ProductActions = ({
  open,
  toggle,
  selectIng,
  removeProduct,
  changePrice,
  addComment,
  product_key,
}) => {
  return (
    <Modal isOpen={open} toggle={toggle}>
      <ModalHeader>Opciones</ModalHeader>
      <ModalBody>
        <div className="d-sm-block w-100 justify-content-between">
          <button
            type="button"
            className="btn btn-block btn_xs_lg btn-outline-dark btn-sm text-center ch_price"
            data-product_key={product_key}
            onClick={selectIng}
          >
            <i className="fas fa-pen icon_fixed_l "></i> Ingredientes
          </button>
          <button
            type="button"
            className="btn btn-block btn_xs_lg btn-outline-dark btn-sm text-center ch_price"
            data-product_key={product_key}
            onClick={changePrice}
          >
            <i className="fas icon_fixed_l fa-dollar-sign"></i> Cambiar Precio
          </button>
          <button
            type="button"
            className="btn btn-block btn_xs_lg btn-outline-dark btn-sm text-center"
            data-product_key={product_key}
            data-type="product"
            onClick={addComment}
          >
            <i className="far icon_fixed_l fa-comment"></i> Agregar Comentario
          </button>
          <button
            type="button"
            className="btn btn-block btn_xs_lg btn-outline-danger btn-sm text-center"
            data-product_key={product_key}
            onClick={removeProduct}
          >
            <i className="fas icon_fixed_l fa-trash"></i> Quitar Producto
          </button>
        </div>
      </ModalBody>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-link btn-block btn_xs_lg"
          onClick={toggle}
        >
          Cancelar
        </button>
      </div>
    </Modal>
  );
};

const ListMov = ({ product, openOptions, index }) => {
  const byX =
    product.qty > 1 ? (
      <div className="col text-right">
        <p className="my-0">
          {" "}
          x{product.qty} | ${product.price / product.qty} c/u
        </p>
      </div>
    ) : null;

  return (
    <button
      className="list-group-item list-group-item-action flex-column align-items-start pb-0 hover_cta_cont"
      data-product_key={index}
      onClick={openOptions}
    >
      <div className="row py-1">
        <div className="col-9">
          <h5 className="mb-1">{product.title}</h5>
        </div>
        <div className="col-3 text-right">
          <h4>
            <b>${product.price}</b>
          </h4>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <p className="my-0">{product.text ? product.text : "Con Todo"} </p>
        </div>
        {byX}
      </div>
    </button>
  );
};

const Delivery = ({ type, checked, click }) => {
  let info = null;
  switch (type) {
    case "for_here":
      info = {
        text: "En Comedor",
        icon: "fas fa-stop-circle",
      };
      break;

    case "pickup":
      info = {
        text: "Para Recoger",
        icon: "far fa-hand-point-up",
      };
      break;
    case "delivery":
      info = {
        text: "A Domicilio",
        icon: "fa fa-motorcycle",
      };
      break;
    case "other_apps":
      info = {
        text: "Plataformas",
        icon: "fas fa-mobile-alt",
      };
      break;

    default:
      info = {
        text: "En Comedor",
        icon: "fas fa-stop-circle",
      };
      break;
  }
  return (
    <button
      className={`btn btn-outline-dark btn_xs_lg btn-block ${
        checked ? "active" : null
      } btn_check_delivery`}
      onClick={click}
      data-type={type}
    >
      <i className={info.icon} aria-hidden="true"></i> {info.text}
    </button>
  );
};

const ChooseIngredients = ({ ingredients, text, click, product }) => (
  <div>
    <div className="ing_cont">
      {ingredients
        .sort((a, b) => (a.name > b.name ? 1 : -1))
        .map((ingredient) => {
          return (
            <Ingredient
              info={ingredient}
              key={`ingredient_set_${ingredient.id}`}
              active={hasIngredient(product.ingredientsSel, ingredient.id)}
              click={click}
            />
          );
        })}
    </div>
    <h3 className="text-center">{text}</h3>
  </div>
);
